import React from 'react';
import { compose } from 'ramda';

import styleFile from './AvailServiceHeader.js';
import { RichText, Button } from '@synergycms_core/components/generic/';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';

const AvailServiceHeader = class AvailServiceHeader extends React.Component {
  static displayName = 'AvailServiceHeader';

  render() {
    const { classes } = this.props.theme.styles;
    const { disableNextStepButton } = this.props.config;

    return (
      <div className={classes.defaultStyle}>
        <div className={classes.content}>
          <div className={classes.firstColumn}>
            <RichText
              text={'_%personaliza tu estancia añadiendo extras%_'}
              translate={true}
              ucFirst={true}
              innerStyle={[classes.textSpan]}
            />
          </div>
          <div className={classes.secondColumn}>
            <Button 
              id={'td-d2-continue-extras-00'} 
              onClick={this.props.config.onNextClick}
              disabled={disableNextStepButton}
              innerStyle={[
                'toggleSecondButton', 
                'summary', 
                classes.robotoBtn
              ]} 
              ariaLabel={'_%continuar para reservar%_'} 
              translate={true}>
              <RichText
                rightIcon={{ unicodeContent: this.props.config.langCode === 'AR' ? '005C' : 'e000', innerStyle: ['size12', 'marginLeft14'] }}
                text={'_%continuar para reservar%_'}
                translate={true}
                ucFirst={true}
                innerStyle={[classes.textSpan]}
              />
            </Button>
          </div>
        </div>
        {disableNextStepButton ? (
          <div className={classes.thirdColumn}><RichText 
            translate={true}
            innerStyle={[classes.textSpan, 'mainColor']}
            ucFirst={true}
            text={"_%revisa las horas seleccionadas%_"}/></div>) : null}
      </div>
    );
  }
};

export default compose(
  PropertyManager(['onNextClick', 'langCode', 'disableNextStepButton']),
  withThemeJSS({ styleFile })
)(AvailServiceHeader);
